/**
 * WorkspaceSkeleton — a minimal, polished loading state for the patient workspace.
 *
 * Shows a full-screen dark canvas with a subtle radial gradient and
 * full-width staggered skeleton bars.
 * Intentionally lightweight with no split-pane framing or divider.
 */
export function WorkspaceSkeleton() {
  return (
    <div className="flex h-screen w-screen flex-col bg-background">
      {/* Subtle radial gradient backdrop */}
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_40%,var(--primary)/4%,transparent)]"
        aria-hidden="true"
      />

      {/* Full-width staggered skeleton lines */}
      <div className="relative flex flex-1 overflow-hidden">
        <div className="flex h-full w-full flex-col px-6 pt-6">
          <div className="space-y-4">
            <div className="h-3 w-1/4 animate-pulse rounded-full bg-gradient-to-r from-muted/60 via-muted to-muted/60" />
            <div className="h-3 w-2/3 animate-pulse rounded-full bg-gradient-to-r from-muted/50 via-muted/80 to-muted/50 [animation-delay:100ms]" />
            <div className="h-3 w-5/12 animate-pulse rounded-full bg-gradient-to-r from-muted/45 via-muted/70 to-muted/45 [animation-delay:180ms]" />
            <div className="h-3 w-3/4 animate-pulse rounded-full bg-gradient-to-r from-muted/40 via-muted/70 to-muted/40 [animation-delay:240ms]" />
            <div className="h-3 w-1/2 animate-pulse rounded-full bg-gradient-to-r from-muted/35 via-muted/65 to-muted/35 [animation-delay:320ms]" />
            <div className="h-3 w-11/12 animate-pulse rounded-full bg-gradient-to-r from-muted/30 via-muted/60 to-muted/30 [animation-delay:400ms]" />
            <div className="h-3 w-7/12 animate-pulse rounded-full bg-gradient-to-r from-muted/35 via-muted/65 to-muted/35 [animation-delay:480ms]" />
            <div className="h-3 w-4/5 animate-pulse rounded-full bg-gradient-to-r from-muted/40 via-muted/70 to-muted/40 [animation-delay:560ms]" />
          </div>
        </div>
      </div>
    </div>
  );
}
